import { ESBitbucketCommit } from '../../models/git-commit';
import { Action } from '../../../../ngrx/actions/unsafe-action';

export const UPDATED = '[bitbucket-commit.actions] UPDATED BITBUCKET COMMITS';
export const GET_TASK_COMMIT = '[bitbucket-commit.actions] get bitbucket commits by task';
export const GET_TASK_COMMIT_COMPLETE = '[bitbucket-commit.actions] get taskCommit complete';
export const DELETE_TASK_COMMIT = '[bitbucket-commit.actions] remove taskCommit';
export const GET_TASK_COMMIT_FAIL = '[bitbucket-commit.actions] GET_TASK_COMMIT_FAIL';

export class GetTaskCommit implements Action {
  readonly type = GET_TASK_COMMIT;

  constructor(public payload: { task: number }) {}
}

export class Updated implements Action {
  readonly type = UPDATED;

  constructor(public payload: ESBitbucketCommit) {}
}

export class GetTaskCommitComplete implements Action {
  readonly type = GET_TASK_COMMIT_COMPLETE;

  constructor(public payload: { taskId: number; entities: ESBitbucketCommit }) {}
}

export class GetTaskCommitFail implements Action {
  readonly type = GET_TASK_COMMIT_FAIL;
}

export class DeleteTaskCommit implements Action {
  readonly type = DELETE_TASK_COMMIT;

  constructor(public payload: { id: string; taskId: number }) {}
}

// prettier-ignore
export type Actions
  = GetTaskCommit
  | Updated
  | GetTaskCommitComplete
  | DeleteTaskCommit
  | GetTaskCommitFail
  ;
